// export const jobFormValidator = (name, value, setErrors, createJob , manadatroyField) => {

import { Blank } from "../utils/Blank";
import { VALIDATION_MESSAGES } from "../utils/validationMessages";   

//     const newErrors = {};
//     console.log("manadatroyField", name, value)
//     // Job code
//     if (name === "internalJobId" && manadatroyField.internalJobId) {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "This field is required";
//         }
//     }
//     // Job title
//     else if (name === "title" && manadatroyField.title) {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "This field is required";
//         }
//     }
//     // City (multi-select)
//     else if (name === "location.city" && manadatroyField?.location?.city) {
//         if (!value || (Array.isArray(value) && value.length === 0)) {
//             newErrors[name] = "Please select at least one city";
//         }
//     }

//     else if (name === "maxClientBudget.amount") {
//         if (value === "" || value === null) {
//             newErrors[name] = "";
//         }
//         else if (isNaN(value)) {
//             newErrors[name] = "Only numbers are allowed";
//         }
//         else if (Number(value) <= 0) {
//             newErrors[name] = "Amount must be greater than 0";
//         }
//     }


//     else if (name === "payRange.min" && manadatroyField?.payRange?.min) {
//         const clientBill = Number(createJob?.maxClientBudget?.amount || 0);
//         const valueNum = Number(value);

//         if (!value || isNaN(valueNum)) {
//             newErrors[name] = "Minimum pay must be a number";
//         }
//         else if (valueNum < 1) {
//             newErrors[name] = "Minimum pay must be 1 or more";
//         }
//         else if (createJob?.payRange?.max && valueNum > Number(createJob.payRange.max)) {
//             newErrors[name] = "Minimum pay cannot be more than Maximum pay";
//         }
//         else if (clientBill && valueNum > clientBill) {
//             newErrors[name] = `Minimum pay cannot be greater than Client Bill Amount (${clientBill})`;
//         }
//     }

//     else if (name === "payRange.max" && manadatroyField?.payRange?.max) {
//         if (!value || isNaN(value)) {
//             newErrors[name] = "Maximum pay must be a number";
//         } else if (Number(value) < (createJob?.payRange?.min || 1)) {
//             newErrors[name] = "Maximum pay must be equal or more than Minimum pay";
//         }
//     }

//     else if (name === "startDate") {
//         if (!value) {
//             newErrors[name] = "Start date is required";
//         }
//         else if (createJob?.endDate && new Date(value) > new Date(createJob.endDate)) {
//             newErrors[name] = "Start Date must be before End Date";
//         }
//     }

//     else if (name === "endDate") {
//         if (!value) {
//             newErrors[name] = "End date is required";
//         }
//         else if (createJob?.startDate && new Date(value) < new Date(createJob.startDate)) {
//             newErrors[name] = "End Date must be after Start Date";
//         }
//     }


//     else if (name === "endDate") {
//         if (createJob?.startDate) {
//             if (!value) {
//                 newErrors[name] = "End date is required";
//             }
//             else if (new Date(value) < new Date(createJob.startDate)) {
//                 newErrors[name] = "End Date must be after Start Date";
//             }
//         }
//     }

//     else if (name === "maxClientBudget.amount") {
//         if (value === "" || value === null) {
//             newErrors[name] = "Amount is required";
//         }
//         else if (isNaN(value)) {
//             newErrors[name] = "Only numbers are allowed";
//         }
//         else if (Number(value) <= 0) {
//             newErrors[name] = "Amount must be greater than 0";
//         }
//     }
    
   
//     else if (name === "jobType" && manadatroyField.jobtype) {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "Job type is required";
//         }
//         else if (!/^[A-Za-z\s]+$/.test(value)) {
//             newErrors[name] = "Only letters are allowed";
//         }
//     }

//     else if (name === "mode" && manadatroyField?.mode) {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "Mode is required";
//         }
//         else if (!/^[A-Za-z\s]+$/.test(value)) {
//             newErrors[name] = "Only letters are allowed";
//         }
//     }

//     else if (name === "industry" && manadatroyField?.industry) {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "Industry is required";
//         }
//         else if (!/^[A-Za-z\s]+$/.test(value)) {
//             newErrors[name] = "Only letters are allowed";
//         }
//     }

//     else if (name === "noticePeriod" && manadatroyField?.noticeperiod){
//         if (!value || value.trim() === "") {
//             newErrors[name] = "noticePeriod is required";
//         }
//         else if (!/^[A-Za-z\s]+$/.test(value)) {
//             newErrors[name] = "Only letters are allowed";
//         }
//     }

//     else if (name === "priority") {
//         if (!value || value.trim() === "") {
//             newErrors[name] = "priority is required";
//         }
//         else if (!/^[A-Za-z\s]+$/.test(value)) {
//             newErrors[name] = "Only letters are allowed";
//         }
//     }

//     else if (name === "vacancies") {
//         if (value === "" || value === null) {
//             newErrors[name] = "Vacancies is required";
//         }
//         else if (isNaN(value)) {
//             newErrors[name] = "Only numbers are allowed";
//         }
//         else if (Number(value) <= 0) {
//             newErrors[name] = "Vacancies must be greater than 0";
//         }
//     }

//     else if (name === "experience.min" && manadatroyField?.experience?.min) {
//         if (value === "" || value === null) {
//             newErrors[name] = "Minimum experience is required";
//         }
//         else if (isNaN(value)) {
//             newErrors[name] = "Only numbers are allowed";
//         }
//         else if (Number(value) < 0) {
//             newErrors[name] = "Minimum experience cannot be negative";
//         }
//         else if (createJob?.experience?.max !== undefined && createJob.experience.max !== "") {
//             const minVal = Number(value);
//             const maxVal = Number(createJob.experience.max);
//             if (minVal > maxVal) {
//                 newErrors[name] = "Min experience cannot be greater than Max experience";
//             }
//         }
//     }

//     else if (name === "experience.max" && manadatroyField?.experience?.max) {
//         if (value === "" || value === null) {
//             newErrors[name] = "Maximum experience is required";
//         }
//         else if (isNaN(value)) {
//             newErrors[name] = "Only numbers are allowed";
//         }
//         else if (Number(value) < 0) {
//             newErrors[name] = "Maximum experience cannot be negative";
//         }
//         else if (createJob?.experience?.min !== undefined && createJob.experience.min !== "") {
//             const minVal = Number(createJob.experience.min);
//             const maxVal = Number(value);
//             if (maxVal < minVal) {
//                 newErrors[name] = "Max experience cannot be less than Min experience";
//             }
//         }
//     }

//     else if(name === "skills" && manadatroyField?.skills){
//         if(!value || (Array.isArray(value) && value.lenght === 0)){
//             newErrors[name] = "This field is requires"
//         }
//     }


//     // Update errors state
//     setErrors((prev) => ({
//         ...prev,
//         ...newErrors,
//         ...(newErrors[name] ? {} : { [name]: "" }) // clear previous error if valid
//     }));

//     // Return boolean if field is valid
//     return !newErrors[name];
// };




export const jobFormValidator = (name, value, setErrors, copy) => {

    const newErrors = {};

    // ---------- BASIC TEXT FIELDS ----------
    if (name === "internalJobId" || name === "title") {
        if (Blank(value)) {
            newErrors[name] = VALIDATION_MESSAGES?.REQUIRED;
        }
    }

    // ---------- PAY RANGE ----------
    if (name === "payRange.min") {
        const minValue = Number(value);
        const maxValue = Number(copy?.payRange?.max || 0);
        const clientBill = Number(copy?.maxClientBudget?.amount || 0);

        if (isNaN(minValue)) newErrors[name] = "Minimum pay must be a number";
        else if (minValue < 1) newErrors[name] = "Minimum pay must be 1 or more";
        else if (maxValue && minValue > maxValue)
            newErrors[name] = "Minimum pay cannot exceed Maximum pay";
        else if (clientBill && minValue > clientBill)
            newErrors[name] = `Minimum pay cannot exceed Client Bill Amount (${clientBill})`;
    }

    if (name === "payRange.max") {
        const maxValue = Number(value);
        const minValue = Number(copy?.payRange?.min || 1);

        if (isNaN(maxValue)) newErrors[name] = "Maximum pay must be a number";
        else if (maxValue < minValue)
            newErrors[name] = "Maximum pay must be ≥ Minimum pay";
    }

    // ---------- SELECT FIELDS ----------
    if (["jobType", "mode", "industry", "noticePeriod"].includes(name)) {
        if (Blank(value?.value)) {
            newErrors[name] = VALIDATION_MESSAGES?.REQUIRED;
        }
    }

    // Objects with ID
    if (["reportingManager", "primaryRecruiter", "client", "spoc"].includes(name)) {
        if (Blank(value?.id)) {
            newErrors[name] = { id: VALIDATION_MESSAGES?.REQUIRED };
        }
    }

    // Arrays (tags/select multi)
    if (["assignedTo", "city", "skills"].includes(name)) {
        if (Blank(value)) {
            newErrors[name] = VALIDATION_MESSAGES?.REQUIRED;
        }
    }


    // ---------- EXPERIENCE ----------
    if (name === "experience.min") {
        const minValue = Number(value);
        const maxValue = Number(copy?.experience?.max || 0);

        if (isNaN(minValue)) newErrors[name] = "Minimum experience must be a number";
        else if (minValue < 0) newErrors[name] = "Minimum experience cannot be negative";
        else if (maxValue && minValue > maxValue)
            newErrors[name] = "Minimum experience cannot exceed Maximum experience";
    }

    if (name === "experience.max") {
        const maxValue = Number(value);
        const minValue = Number(copy?.experience?.min || 1);

        if (isNaN(maxValue)) newErrors[name] = "Maximum experience must be a number";
        else if (maxValue < minValue)
            newErrors[name] = "Maximum experience must be ≥ Minimum experience"; 
    }
 


    // ---------- DATES ----------
    if (name === "startDate") {
        if (Blank(value)) newErrors[name] = "Start date is required"; 
        else if (copy?.endDate && new Date(value) > new Date(copy.endDate))  
            newErrors[name] = "Start Date must be before End Date";
    }

    if (name === "endDate") {
        if (Blank(value)) newErrors[name] = "End date is required";
        else if (copy?.startDate && new Date(value) < new Date(copy.startDate))
            newErrors[name] = "End Date must be after Start Date";
    }

    // ---------- UPDATE ERRORS ----------
    setErrors((prev) => ({
        ...prev,
        [name]: newErrors[name] ?? ""
    }));

    return !newErrors[name];
};














